<mat-card>
    <mat-card-content>
        <h1 class="title mat-display-1">¿Qué tipo de vehículo quieres asegurar?</h1>

        <mat-grid-list [cols]="cols" rowHeight="2:1" gutterSize="5px">
            <mat-grid-tile>
                <a routerLink="/price-form/modernos" class="tile-link" aria-label="Vehículos modernos">
                    <img src="/assets/vehiculos-modernos.svg" alt="Vehículos modernos" class="vehicle-image" />
                </a>
            </mat-grid-tile>

            <mat-grid-tile>
                <a routerLink="/price-form/clasicos" class="tile-link" aria-label="Vehículos clásicos">
                    <img src="/assets/vehiculos-clasicos.svg" alt="Vehículos clásicos" class="vehicle-image" />
                </a>
            </mat-grid-tile>

            <mat-grid-tile>
                <a routerLink="/price-form/campers" class="tile-link" aria-label="Campers">
                    <img src="/assets/campers.svg" alt="Campers" class="vehicle-image" />
                </a>
            </mat-grid-tile>

            <mat-grid-tile>
                <a routerLink="/price-form/autocaravanas" class="tile-link" aria-label="Autocaravanas">
                    <img src="/assets/autocaravanas.svg" alt="Autocaravanas" class="vehicle-image" />
                </a>
            </mat-grid-tile>
        </mat-grid-list>
    </mat-card-content>
</mat-card>